import { render, staticRenderFns } from "./MarketingLanding.vue?vue&type=template&id=3b29ffdb&scoped=true&"
import script from "./MarketingLanding.vue?vue&type=script&lang=ts&"
export * from "./MarketingLanding.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingLanding.vue?vue&type=style&index=0&id=3b29ffdb&prod&scoped=true&lang=scss&"
import style1 from "./MarketingLanding.vue?vue&type=style&index=1&id=3b29ffdb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29ffdb",
  null
  
)

export default component.exports